import { Component, Mixins, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'

import ProjectModel from '@/views/Project/Project/models/project'

@Component({
    name: 'project-close',
    components: { DialogTemplate },
})
export default class ProjectClose extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    testText = ''
    loading = false
    closeError = false

    get testPassed() {
        const normalize = (str: string) =>
            str.replace(/[\u200B-\u200D\uFEFF\u00A0\s]/g, '').toLowerCase()
        return normalize(this.testText) === normalize(this.project.name)
    }

    get project(): ProjectModel {
        return this.props.project
    }

    get notClosedModules() {
        return this.project.modules.filter((module) => {
            return module.status !== 'deleted'
        })
    }

    get hasNotClosedModules() {
        return this.project.modules.findIndex((module) => module.status !== 'deleted') > -1
    }

    async submit() {
        if (this.testPassed && this.hasNotClosedModules) {
            this.loading = true
            await Promise.all(
                this.project.modules.map(async (module) => {
                    if (module.status != 'deleted') {
                        await module.patch('deleted').catch(() => {
                            //
                        })
                    }
                })
            )
            if (this.hasNotClosedModules) {
                this.closeError = true
            } else {
                this.$emit('close', false)
            }
            this.loading = false
        }
    }
}
